import { type ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ENV_MODULE_TOKEN } from './env.module.token';

@NgModule({
    imports: [CommonModule],
})
export class EnvModule {
    static forRoot<T>(env: T): ModuleWithProviders<EnvModule> {
        return {
            ngModule: EnvModule,
            providers: [
                {
                    provide: ENV_MODULE_TOKEN,
                    useValue: env,
                },
            ],
        };
    }
}
